import { useT } from '../../../i18n';
import { soVN } from '../../../lib/dinh-dang';
import { Skeleton } from '../../../components/ui';
import { useLoi } from '../../../hooks/useLoi';
import { useTokenTheoModel } from '../hooks/useGoiNapToken';

/**
 * "Theo model" trong "Cách tính hạn mức" (ADR-0100 mục 1): token thật của từng model, hệ số, và token Fox đã trừ vào
 * hạn mức trong tháng. Chỉ tải khi khối được mở (`batDau`).
 */
export function TokenTheoModel({ tenantId, batDau }: { tenantId: string; batDau: boolean }) {
  const { t, locale } = useT();
  const dichLoi = useLoi();
  const q = useTokenTheoModel(tenantId, batDau);

  return (
    <section className="space-y-1.5 border-t border-default pt-2" aria-labelledby={`theo-model-${tenantId}`}>
      <h4 id={`theo-model-${tenantId}`} className="text-xs font-semibold text-content-secondary">
        {t('banToken.theoModel.tieuDe')}
      </h4>
      {q.isLoading ? (
        <div className="space-y-1.5" aria-busy>
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-2/3" />
        </div>
      ) : q.error ? (
        <p role="alert" className="text-xs text-danger-700">
          {t('banToken.theoModel.loi', { loi: dichLoi(q.error) })}
        </p>
      ) : !q.data || q.data.items.length === 0 ? (
        <p className="text-xs text-content-muted">{t('banToken.theoModel.rong')}</p>
      ) : (
        <table className="w-full text-xs tabular-nums">
          <caption className="sr-only">{t('banToken.theoModel.caption')}</caption>
          <thead>
            <tr className="text-content-muted">
              <th scope="col" className="py-1 text-left font-normal">
                {t('banToken.theoModel.cotModel')}
              </th>
              <th scope="col" className="py-1 text-right font-normal">
                {t('banToken.theoModel.cotThat')}
              </th>
              <th scope="col" className="py-1 text-right font-normal">
                {t('banToken.theoModel.cotHeSo')}
              </th>
              <th scope="col" className="py-1 text-right font-normal">
                {t('banToken.theoModel.cotFox')}
              </th>
            </tr>
          </thead>
          <tbody className="text-content-secondary">
            {q.data.items.map((d) => (
              <tr key={d.model_key ?? '-'} className="border-t border-default">
                <th scope="row" className="max-w-[10rem] truncate py-1 text-left font-normal text-content-primary">
                  {d.label ?? d.model_key ?? t('banToken.theoModel.khongModel')}
                </th>
                <td className="py-1 text-right">{soVN(d.raw_tokens, locale)}</td>
                <td className="py-1 text-right">{t('banToken.heSo.nhan', { so: d.he_so_token.toLocaleString(locale) })}</td>
                <td className="py-1 text-right text-content-primary">{soVN(d.fox_tokens, locale)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
